import { ConfigProvider } from 'antd';
import React, { ReactNode } from 'react';
import { DefaultTheme } from 'styled-components';

export type AntdProviderAuthPropsT = {
  theme: DefaultTheme;
  children: ReactNode;
};

export const AuthModalAntdProvider = ({ theme, children }: AntdProviderAuthPropsT) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: { paddingLG: 0 },
          Button: {
            colorLink: theme.Color.Brand.Primary,
            colorLinkHover: theme.Color.Neutrals.Text,
            colorLinkActive: theme.Color.Neutrals.Text,
            controlHeight: theme.Sizes.X6Large,
          },
          Checkbox: {
            colorBorder: theme.Color.Neutrals.Border,
            paddingXS: theme.Spacing.Size.Small,
          },
          Form: {
            verticalLabelPadding: 0,
          },

          Input: {
            controlHeight: theme.Form.InputSize.Medium.height,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
